import * as LocationTypes from "./locationTypes";
import * as ServiceTypes from "./serviceTypes";
import * as ProviderTypes from "./providerTypes";
import * as ClientTypes from "./clientTypes";
import * as DateTypes from "./dateTypes";
import * as moment from "moment";
import * as AccountStoreTypes from "../../Account/DataTypes/storeTypes";
import * as StripeTypes from "../../Common/Stripe/types";

export interface IInitialSettings {
    cancelUrl: string;
    getServicesUrl: string;
    getAllServicesUrl: string;
    getLocationsUrl: string;
    getProvidersUrl: string;
    getAvailabilityUrl: string;
    getClientsUrl: string;
    bookUrl: string;
    validateBookingUrl: string;
    isTimezonesEnabled: boolean;
    isUserLoggedIn: boolean;
    loggedInClientId: number;
    type: BookingType;
    getCreditCardUrl: string;
    createSCAIntent: string;
    revokeCardConsent?: string;
    createOrUpdateCustomer: string;
    cdnHost: string;
    accountInitialSettings: AccountStoreTypes.IInitialSettings;
    getDefaultGroupServiceUrl: string;
    stripeFeeEnabled: boolean;
    calculateStripeSurchargeUrl: string;
}

export interface IStore {
    initialSettings: IInitialSettings;

    common: ICommon;

    stepsInfo: IStepsInfo;

    servicesData: ServiceTypes.IServicesData;

    locations: LocationTypes.ILocation[];

    providers: ProviderTypes.IProvider[];

    availability: DateTypes.Availability;

    submitForm: any;
}

export interface ICommon {
    isPageLoading: boolean;
    isBusy: boolean;

    isUserLoggedIn: boolean;

    loggedInClientId: number;

    currentStep: Step;

    bookedAppointment?: any;

    cancelRequested: boolean;

    clients: ClientTypes.IClient[];
}

export enum Step {
    Location,
    Service,
    Provider,
    When,
    Login,
    Confirmation,
    Group, // not a real step, it is used to render group name on summary page
}

export interface IStepInfo {
    id: number;
    summary: string;
}

export interface IServiceStepInfo extends IStepInfo {
    id: number;
    summary: string;
    selectedCategory: string;
    amount?: number;
    totalAmount?: number;
    displayAmount?: number;
    displayTotalAmount?: number;
    hasPortalDeposit: boolean;
    isPortalDeposit: boolean;
    amountFee?: number;
    totalAmountFee?: number;
}

export interface IAvailabilityStepInfo extends IStepInfo {
    start: moment.Moment;
    selectedDate?: moment.Moment;
    navigationDate?: moment.Moment;
    slot?: DateTypes.ISlot;
}

export interface IConfirmationStepInfo extends IStepInfo {
    showAddNotes: boolean;
    showStripe: boolean;
    cardInfo?: StripeTypes.ICardInfo;
    isEditCreditCard: boolean;
    clientId: number; //it must have value always, either it is assigned in storeManager initially, or after log in.
    idempotencyKey?: string;
}

export interface IStepsInfo {
    [key: number]: IStepInfo;
}

export enum BookingType {
    Client,
    Class,
}
